/**
 Add more util fns for SMP in this file as needed
 */

import { accountTypes } from './utils';
import { meetsSummitIClassEligibility } from './summit.testers';
import { meetsIClassEligibility } from './testers';

export const minimumSummitIClassInvestAmount = 50000;

export const tierTypes = {
  NONE: 0,
  CORE: 1,
  SELECT: 3,
  PERSONAL_SERVICE: 4,
  ENHANCED_PERSONAL_SERVICE: 5
};

export const tierTypesArray = [
  { id: tierTypes.NONE, name: 'NONE', minHouseholdBalance: 0, minInvAmount: 0 },
  {
    id: tierTypes.CORE,
    name: 'General Services Member',
    minHouseholdBalance: 0,
    minInvAmount: 0
  },
  {
    id: tierTypes.SELECT,
    name: 'Select Services Member',
    minHouseholdBalance: 250000,
    minInvAmount: 0
  },
  {
    id: tierTypes.PERSONAL_SERVICE,
    name: 'Personal Services Member',
    minHouseholdBalance: 500000,
    minInvAmount: minimumSummitIClassInvestAmount
  },
  {
    id: tierTypes.ENHANCED_PERSONAL_SERVICE,
    name: 'Enhanced Personal Services Member',
    minHouseholdBalance: 1000000,
    minInvAmount: 0
  }
];

export const tierRewards = {
  [tierTypes.NONE]: {
    closedFunds: false,
    iClassFunds: false
  } /* not a summit member; default */,
  [tierTypes.CORE]: { closedFunds: false, iClassFunds: false },
  [tierTypes.SELECT]: { closedFunds: true, iClassFunds: false },
  [tierTypes.PERSONAL_SERVICE]: { closedFunds: true, iClassFunds: true },
  [tierTypes.ENHANCED_PERSONAL_SERVICE]: {
    closedFunds: true,
    iClassFunds: true
  },
  NONE: { closedFunds: false, iClassFunds: false }
};

export const unlockRewards = (tierID: number): any => tierRewards[tierID];

/* export const unlockRewards = (tierID: number): any => {
  const tierIndex = tierTypesArray.findIndex(tier => tier.id === tierID);
  
  if (tierIndex !== -1) {
      return tierRewards[tierTypesArray[tierIndex].id];
  } else {
    return tierRewards[0];
  }
}; */

export const getTier = (amount, eligible): number => {
  if (!eligible) return 0;
  const currentTier = tierTypesArray.find(
    tier => amount >= tier.minHouseholdBalance
  );
  return currentTier?.id || 0;
};

export const getNextTier = (amount: number): any => {
  const nextTier = tierTypesArray.find(
    tier => tier.minHouseholdBalance > amount
  );
  return nextTier ? nextTier.id : null;
};

export const getTierMinimum = (tierID: number): any =>
  tierTypesArray.find(tier => tier.id === tierID)?.minHouseholdBalance || 0;

export const getAmountToNextTier = (amount: number): number => {
  const nextTier = tierTypesArray.find(
    tier => tier.minHouseholdBalance > amount
  );
  /* eslint-disable no-unsafe-optional-chaining */
  return nextTier ? nextTier?.minHouseholdBalance - amount : 0;
};

export const doSSNsMatch = (trust, trustee): boolean => {
  return trust?.taxID === trustee?.taxID;
};

const noRewardsFilter = { closedFunds: false, iClassFunds: false };

export const getRewardsAvailable = (
  accountType,
  trust,
  trustee,
  assetTierID
): any => {
  if (accountType === accountTypes.TRUST && !doSSNsMatch(trust, trustee)) {
    return noRewardsFilter;
  }
  return unlockRewards(assetTierID);
};

export const parseIClassFunds = (
  funds: any[],
  updateIClass: boolean,
  summitData: any = {}
): any[] =>
  updateIClass
    ? funds.map(fund => {
        const { amount, percent, correspondingFund } = fund;
        return meetsSummitIClassEligibility(fund, summitData?.assetTierID) ||
          meetsIClassEligibility(fund)
          ? { amount, percent, ...correspondingFund, unlockedFund: true }
          : fund;
      })
    : funds;

export const checkSummitIClassEligibility = (
  amount,
  rewardsAvailable
): boolean => {
  return (
    rewardsAvailable?.iClassFunds && amount >= minimumSummitIClassInvestAmount
  );
};

export const houseHoldSummitData = (householdData): any => {
  return {
    // using minimumAmount property for now until service returns actual totalAssetBalanceAmount
    totalAssetBalanceAmount:
      householdData?.householdBalanceTierStatus?.householdAssetTier
        ?.minimumAmount,
    assetTier:
      householdData?.householdBalanceTierStatus?.householdAssetTier?.name,
    assetTierID:
      householdData?.householdBalanceTierStatus?.householdAssetTier?.id
  };
};
